<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { STATS } from '@/store/types';
import statsApi from '../../apis/stats.api';

export default {
  props: {
    start_date: {
      type: Array,
      default: () => [],
    },
    end_date: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = statsApi.useCommuterImpactsQuery({
      start_date: props.start_date,
      end_date: props.end_date,
    });
    if (query.value) {
      store.commit(STATS.SET_COMMUTER_IMPACTS_QUERY, query);
    }
    return { query };
  },
};
</script>
